module.exports = __webpack_public_path__ + "img/pngwing.com.e57ad32c.png";